import { useEffect, useState } from 'react'

import CopTable from '../CopTable/CopTable'
import './UserManagementRoleExplanation.scss'
import {
    parseRoleExplanationConfig,
    type RoleExplanationTableConfig,
    type UserManagementRoleExplanationProps,
} from './UserManagementRoleExplanation.config'

// Fallback for content authored before the table became configurable via a nested cop-table component.
const DEFAULT_TABLE_CONFIG: RoleExplanationTableConfig = {
    sectionType: 'userManagementRoles',
    enableTable: 'true',
}

const UserManagementRoleExplanation = (props: UserManagementRoleExplanationProps) => {
    const configJson = props.configJson ?? props['config-json'] ?? ''
    const parsedConfig = parseRoleExplanationConfig(configJson)
    const overlayTitle = props.overlayTitle ?? props['overlay-title'] ?? parsedConfig.tooltipTitle ?? 'Role Explanation'
    const tableConfig = parsedConfig.table ?? DEFAULT_TABLE_CONFIG

    const [open, setOpen] = useState(false)

    useEffect(() => {
        const handler = () => setOpen(true)
        window.addEventListener('cop:show-role-explanation', handler)
        return () => window.removeEventListener('cop:show-role-explanation', handler)
    }, [])

    if (!open) return null

    return (
        <div className="um-role-explanation__overlay">
            <dialog
                open
                className="um-role-explanation__dialog"
                aria-labelledby="um-role-explanation-title"
                onKeyDown={e => { if (e.key === 'Escape') setOpen(false) }}
            >
                <div className="um-role-explanation__header">
                    <h3 id="um-role-explanation-title" className="um-role-explanation__title">{overlayTitle}</h3>
                    <button
                        type="button"
                        className="um-role-explanation__close"
                        onClick={() => setOpen(false)}
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                <CopTable {...tableConfig} />
            </dialog>
        </div>
    )
}

export default UserManagementRoleExplanation
